import React from 'react';
import SimpleTable from 'common/table/SimpleTable';

const DealIssuanceDocuments = (props)=>{
    const{data, config} =props;
    return(<SimpleTable config={config} data={data}/>);
}
export default DealIssuanceDocuments;